import React, { useEffect } from 'react';

import { classNames } from '../../utils/style';
import { useParams } from '../../utils/useParams';
import { useScreenSize } from '../../utils/utils';
import { toBoolean } from '../../utils/toBoolean';

export const BoxButton = ({
  btns,
  initialValue,
  name,
  label,
  className,
  labelClassName,
  buttonClassName,
}: any) => {
  const screen = useScreenSize();
  const isSmall = ['xs'].includes(screen);

  const [params, setParams] = useParams();
  useEffect(() => {
    if (
      initialValue &&
      !params?.[name] &&
      initialValue !== toBoolean(params?.[name])
    )
      setParams(name, initialValue.toString());
  }, [initialValue, name, params, setParams]);
  return (
    <div
      className={classNames(
        'BoxButton',
        'rounded-[18px] p-24 gap-6',
        'flex font-sans text-14',
        'm-auto mb-56',
        'flex-col',
        isSmall && 'flex-wrap',
        !isSmall && 'bg-white',
        className,
      )}
    >
      {label && <p className={classNames(labelClassName)}>{label}</p>}
      <div className={classNames('flex gap-12')}>
        {btns?.length > 0 &&
          btns.map(({ label: _label, value }: any, key: number) => {
            const selected = value.toString() === params?.[name];

            return (
              <button
                key={key}
                className={classNames(
                  selected && 'border-blue-101 ',
                  !selected && 'border-silver-100 ',
                  'px-16 py-8 rounded-[6px]',
                  'w-fit m-auto bg-white',
                  'border-2 border-solid',
                  isSmall && 'mb-4',
                  'flex-1',
                  buttonClassName,
                )}
                onClick={() => {
                  setParams(name, value.toString());
                }}
              >
                {_label}
              </button>
            );
          })}
      </div>
    </div>
  );
};
